import { useSyncExternalStore } from "react";

/** navigator.onLine as a hook (§16.1: the Online/Offline pill follows it). */
function subscribe(cb: () => void) {
  window.addEventListener("online", cb);
  window.addEventListener("offline", cb);
  return () => {
    window.removeEventListener("online", cb);
    window.removeEventListener("offline", cb);
  };
}
export const isOnline = (): boolean => (typeof navigator === "undefined" ? true : navigator.onLine !== false);
export const useOnline = (): boolean => useSyncExternalStore(subscribe, isOnline, () => true);
